module.exports = __webpack_public_path__ + "assets/img/stream-carbon.ae859f7e.png";